import "./ManagementMenu.scss";
import { AddIcon } from "../../components/kits/Icons/Icons";
import { useState } from "react";
import { CustomInput } from "../kits/inputs/Input";
import colorschema from "../../assets/kits/colors/colors.module.scss";
import Items from "./Items";

export default function ManagmentMenu() {
  const [titleBtn, setTitleBtn] = useState([
    { title: "1نام دسته بندی", product_count: "1" },
    { title: "2نام دسته بندی", product_count: "1" },
    { title: "3نام دسته بندی", product_count: "1" },
    { title: "4نام دسته بندی", product_count: "1" },
    { title: "5نام دسته بندی", product_count: 0 },
  ]);
  const [activeBtn, setActiveBtn] = useState(-1);
  const [items, setItems] = useState([
    { img: "", name: "نام محصول اینجاست", price: "12000", inventory: "800" },
    { img: "", name: "نام محصول اینجاست", price: "12000", inventory: "800" },
    { img: "", name: "نام محصول اینجاست", price: "12000", inventory: "800" },
  ]);

  return (
    <div className="p-managMenu">
      <div className="section-a">
        <div
          style={{ whiteSpace: "nowrap" }}
          className="mr-r-8 title title-h3-b  "
        >
          مدیریت منو{" "}
        </div>
        <div className="d-flex box-add">
          <div>
            <AddIcon width="20px" height="20px"></AddIcon>
          </div>
          <div className="txt txt-t2-m ">افزودن محصول</div>
        </div>
      </div>
      <div className="line mr-t-8"></div>
      <div className="d-flex mr-t-16 pd-l-20  pd-r-20 box-btn pd-b-8">
        <div>
          <button
            className={`desc-m btn-category    ${
              activeBtn === -1 && "  btn-active"
            }`}
            // className="desc-m btn-category "
            onClick={(e) => {
              setActiveBtn(-1);
              //   SearchStoreFun();
            }}
          >
            همه
          </button>
        </div>
        <>
          {titleBtn?.map((val, ind) => {
            return (
              <div>
                {val.product_count == 0 ? (
                  <button
                    style={{ display: "none" }}
                    className={`desc-m btn-category btn-disable `}
                    disabled={true}
                  >
                    {val.title}
                  </button>
                ) : (
                  <button
                    className={`desc-m btn-category  ${
                      activeBtn === ind && "btn-active"
                    }`}
                    onClick={(e) => {
                      setActiveBtn(ind);
                    }}
                  >
                    {val.title}
                  </button>
                )}
              </div>
            );
          })}
        </>
      </div>
      <div className="pd-x-16 mr-t-8">
        <CustomInput
          placeholder={`جستجو در محصول های فروشگاه من `}
          haveIcon
          style={{ backgroundColor: colorschema.schema_surface_light }}
          //   value={searchTitle.title}
          //   onChange={(e) => {
          //     searchDebounce.current(e.target.value);

          //     setSearchTitle((prev) => {
          //       return { title: e.target.value };
          //     });
          //   }}
        ></CustomInput>
      </div>
      <div className="pd-x-16 mr-t-16">
        <Items items={items}></Items>
      </div>
    </div>
  );
}
